import React from 'react';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';

const SwitchTimelineInfo = ({ state, status, wfItemId, workflowRestarted }) => {
  const getTooltipContent = (wfItemId) => {
    if (wfItemId < 161) {
      return <span id='pre-swim-switch-missing'><strong>Pre-SWIM Switch</strong> <br /> Missing timeline data</span>;
    } else if (wfItemId < 563) {
      return <span id='pre-swim-switch-incomplete'><strong>Pre-SWIM Switch</strong> <br /> Incomplete timeline data</span>;
    } else {
      return <span id='timeline-is-active'>Timeline is active</span>;
    }
  };

  return (
    <Card style={{ padding: 10 }}>
      <div id="switchTimelineInfoContainer" style={{ textAlign: 'center' }}>
        <strong>
          <span style={{ fontSize: '1.2em' }}>
            <span id="switchState">{state}</span> <small >(<span id="switchStatus">{status}</span>)</small>&nbsp;
            <OverlayTrigger overlay={<Tooltip>{getTooltipContent(wfItemId)}</Tooltip>} placement='right'>
              <Badge bg={wfItemId >= 563 ? 'info' : 'warning'} pill>?</Badge>
            </OverlayTrigger>
          </span>
        </strong>
        {
          workflowRestarted ?
            <span>
              <br />
              <Badge bg='success'>Workflow Restarted</Badge>
            </span>
            : null
        }
      </div>
    </Card>
  );
};

export default SwitchTimelineInfo;
